const defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
export const legacyProjectSettingsCollectorsHelpRoute = {
	name: 'legacy-project-settings-collectors-help',
	path: `/secure/InsertCollectorHelp${defaultSuffix}.jspa`,
	query: ['projectKey'],
};
